
export default {
    getExperiencia(state) {
        return state.experiencia;
    },
    getExperiencias(state) {
        return state.experiencias;
    },
}